var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("pergunta-container " + _vm.classeValidacao),attrs:{"id":("pergunta_id_" + (_vm.pergunta.perguntaId) + "_sessao_pergunta_id_" + (_vm.pergunta.sessaoFormularioPerguntaId))}},[_c(_vm.componentePergunta,{tag:"component",attrs:{"pergunta":_vm.pergunta}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25b5135f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PerguntasComponent/Pergunta.vue
// module id = null
// module chunks = 